import { render, staticRenderFns } from "./VideoScreen.vue?vue&type=template&id=4fd4bd3d&scoped=true&lang=pug&"
import script from "./VideoScreen.vue?vue&type=script&lang=js&"
export * from "./VideoScreen.vue?vue&type=script&lang=js&"
import style0 from "./VideoScreen.vue?vue&type=style&index=0&id=4fd4bd3d&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4bd3d",
  null
  
)

export default component.exports